import { Popover } from "@material-ui/core";
import _ from "lodash";
import * as React from "react";
import MultiSelect from "react-multi-select-component";
import QuiqButton from "src/shared/QuiqButton";
import TextInput from "src/shared/TextInput";
import CloseIcon from "../../../documentUpload/close.svg";
import "./RejectPopover.scss";

import { isRequesting } from "../../../requestProgress/helpers";
import { actions } from "../../../requestProgress/reducer";

export interface RejectPopoverProps {
  spreadId: string;
  periods: string[];
  isOpen: boolean;
  isCreditLens: boolean;
  anchorEl?: HTMLElement | null;
  onClose: (event?: React.SyntheticEvent<{}>) => void;
  onSubmit: (
    spreadId: string,
    reason: string,
    periods: string[],
    isCreditLens: boolean,
    commentText?: string
  ) => void;
}

interface RejectPopoverState {
  reason?: string;
  commentText?: string;
  selectedValues: any;
}

const options = [
  { label: "Wrong Period Dates", value: "Wrong Period Dates" },
  { label: "Wrong Entity", value: "Wrong Entity" },
  { label: "Wrong Template", value: "Wrong Template" },
  { label: "Incomplete Financials", value: "Incomplete Financials" },
  { label: "Breach of a Covenant", value: "Breach of a Covenant" },
  { label: "Poor Quality Report", value: "Poor Quality Report" },
  { label: "Duplicate", value: "Duplicate" },
  { label: "Foreign Language", value: "Foreign Language" },
  { label: "Other", value: "Other" }
];

export class RejectPopover extends React.Component<
  RejectPopoverProps,
  RejectPopoverState
> {
  public constructor(props: RejectPopoverProps) {
    super(props);
    this.state = {
      selectedValues: []
    };
  }

  public render() {
    const { anchorEl, isOpen } = this.props;

    const isLoading = isRequesting(actions.rejectSpread);

    return (
      <div className="RejectPopover">
        <Popover
          open={isOpen}
          anchorEl={anchorEl}
          classes={{ paper: "RejectPopoverPaper" }}
          anchorOrigin={{
            vertical: "top",
            horizontal: "center"
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "center"
          }}
          onClose={this.props.onClose}
          onClick={this.stopPropogation}
        >
          <div className="RejectPopover__header">
            <div className="RejectPopover__header__title">Reject Spread</div>
            <img
              src={CloseIcon}
              className="RejectPopover__header__close-icon"
              onClick={this.props.onClose}
            />
          </div>
          <div className="RejectPopover__select--subtitle">
            Select a Reason for Rejection
          </div>
          <MultiSelect
            className={"rejectDropdown"}
            options={options}
            onChange={this.handleSelectChange}
            labelledBy="Select"
            value={this.state.selectedValues}
            hasSelectAll={false}
            disableSearch={true}
          />

          <div className="RejectPopover__subtitle">
            Please leave an optional comment.
          </div>
          <div>
            <TextInput
              className="RejectPopover__comment--input"
              value={this.state.commentText || ""}
              onChange={this.handleCommentChange}
            />
          </div>
          <QuiqButton
            color="green"
            key="optional-confirm-button"
            className="RejectPopover__optional-confirm-button"
            onClick={this.handleSubmit}
            isDisabled={Boolean(!this.state.reason)}
            isLoading={isLoading}
          >
            Reject Spread
          </QuiqButton>
        </Popover>
      </div>
    );
  }

  public handleSubmit = () => {
    if (this.state.reason) {
      this.props.onSubmit(
        this.props.spreadId,
        this.state.reason,
        this.props.periods,
        this.props.isCreditLens,
        this.state.commentText
      );
    }
  };

  private stopPropogation = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  private handleCommentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ commentText: e.target.value });
  };

  private handleSelectChange = selectedValues => {
    const reason =
      selectedValues.length > 0
        ? _.join((selectedValues || []).map(select => select.value), ",")
        : undefined;
    this.setState({ reason, selectedValues });
  };
}



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/reject/RejectPopover.tsx